export enum recruitmentsSearchTypes {
  FETCH_RECRUIMENTS_SEARCH_REQUEST = "FETCH_RECRUIMENTS_SEARCH_REQUEST",
  FETCH_RECRUIMENTS_SEARCH_SUCCESS = "FETCH_RECRUIMENTS_SEARCH_SUCCESS",
  FETCH_RECRUIMENTS_SEARCH_FAILURE = "FETCH_RECRUIMENTS_SEARCH_FAILURE",
}